import { render } from "./FigureQuestionView.vue?vue&type=template&id=ecf7a26a"
import script from "./FigureQuestionView.vue?vue&type=script&lang=js"
export * from "./FigureQuestionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__